export default __webpack_public_path__ + "static/media/newFolderIcon.bfcbb35b.svg";